import React from "react";
import {
  Paper,
  Typography,
  Button,
} from "@material-ui/core";
import AlertItem from "./AlertItem";

function AlertContainer({
  classes,
  zone,
  zoneId,
  setSelectedAlert,
  setDrawerAlertOpen,
  alerts,
  onActivate,
  loading,
  onEditAlert,
  onDeleteAlert,
}) {
  //const [hover, sethover] = useState(false);

  return (
    <Paper className={classes.container}>
      <Typography className={classes.containerTitle}>{zone}</Typography>
      {alerts &&
        alerts.map((alert, index) => (
          <AlertItem
            key={"alert_" + index}
            alert={{...alert, zoneId}}
            onEditAlert={onEditAlert}
            onDeleteAlert={onDeleteAlert}
            onActivate={onActivate}
            loading={loading}
          />
        ))}
      <Button
        variant="contained"
        size="small"
        color="primary"
        onClick={() => {
          setSelectedAlert({ zoneId });
          setDrawerAlertOpen(true);
        }}
      >
        Add Alert
      </Button>
    </Paper>
  );
}

export default AlertContainer;
